
export default function ExerciserTopContentLayout({children}) {
    // Used in Exercisers to frame top content, made of
    // progress bar, question and answering block

    // BUILD
    return (
        <div className={"w-full flex flex-col justify-start items-center"}>
            {children}
        </div>
    )
}